export const store: Map<string, unknown> = new Map();
